module.exports = __webpack_public_path__ + "img/pin-quantum-core.41bce479.png";